import useBookViewTracking from "hooks/engagement/useBookViewTracking";
import useBookEngagementHeartbeatExit from "hooks/engagement/useBookEngagementHeartbeatExit";
import useEngagementActions from "hooks/engagement/useEngagementActions";

const useBookEngagement = (bookId, options = {}) => {
	useBookViewTracking(bookId, { enabled: options.enabled !== false });
	useBookEngagementHeartbeatExit(bookId, options.heartbeat || {});
	const actions = useEngagementActions(bookId);
	return actions;
};

export default useBookEngagement;
